export default __webpack_public_path__ + "static/pragicts-automation-services-patch-management-9680c05a0c1a545ac9676899965a72ed.jpg";